<template>
  <div v-if="languages.length > 1">
    <div id="usr_TaalKeuzeVue" class="talen" v-if="!mobile || !loggedin">
      <span class="vuefixedlink">
        <a
          class="vuefixedlink talenlink"
          href="javascript:void(0)"
          v-for="(lang, index) in languages"
          :key="'lang' + index"
          @click="changeLang(lang.tblLanguageID)"
          >{{ lang.tblLanguageShortCode }}</a
        >
      </span>
    </div>
    <div v-if="mobile" id="TaallinksMobileMenu">
      <a href="#" v-for="(lang, index) in languages" :key="'lang' + index" @click="changeLang(lang.tblLanguageID)">{{
        lang.tblLanguageShortCode
      }}</a>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { util } from 'pevueglobal'
export default {
  name: 'XVmenuTaalkeuze',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['languages']),
  },
  methods: {
    ...mapActions(['changeLang']),
    loggedin() {
      return util.UgetCookie('kongapikey') !== ''
    },
  },
}
</script>
